export default {
  id: 'Series and number',
  invoiceId: 'Series and number.',
  title: 'General data',
  format: 'Original format',
  created: 'Created',
  issue: 'Date of issue',
  incomeDate: 'Accrual date',
  help: 'This field must be filled if the operation date or prepaid date is not the same as the expedition date of the invoice',
  equalToEmisionDate: 'Same as date of issue',
  billingPeriod: 'Invoice period',
  billPeriod: {
    title: 'Billing period',
    start: 'Start date',
    end: 'End date'
  },
  billProcedure: {
    title: 'Bill payment',
    serie: 'Series and number',
    reason: 'Payment reason'
  },
  extra: {
    title: 'Additional information',
    concept: 'Concept',
    import: 'Attach a new file'
  },
  addFile: {
    type: 'Type',
    description: 'Description*',
    date: 'Created',
    fileTypeInfo: 'To FACe, files with PDF and HTML extension will be admitted'
  },
  serieAndBillNumber: 'Enter series and invoice number manually',
  necessaryToStoreBill: 'This is necessary to be able to store the invoice respecting the series and external number indicated.',
  serie: 'Series',
  number: 'Number',
  sendInvoiceAsPayment: 'If you choose this option, the invoice will be sended to the customer recipient of the invoice as a credit in favor.',
  emissorDiscount: 'Thus, the corresponding amount will be deducted from the account associated with the issuer.',
  contactData: 'Contact data',
  addContactData: 'Add contact data',
  onlyExpenses: 'If you want that the invoice will be only expenses, check the box.',
  rectified: {
    title: 'Corrected invoice',
    reason: 'Corrected reason',
    description: 'Description'
  },
  onlySupplied: 'Only expenses invoice',
  status: 'Status',
  reason: 'Rejection reason'
}
